import {BenjiKIVSpinResultRunner} from "../base/BenjiKIVSpinResultRunner";

/**
 * Created by Jerker Nord on 2022-12-14.
 */

export class BenjiKIVSuperFSResultRunner extends BenjiKIVSpinResultRunner {

}